import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux"
import { Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import TableControl from "pages/parts/TableControl"

import { PGET, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDate, formatDateBackend, findFromArrayById, formatDateWithTime } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxSettings = useSelector(state => state.settings)
	const reduxAccount = useSelector(state => state.account)

	const [poses, setPoses] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [totalAmount, setTotalAmont] = useState([])
	const [data, setData] = useState([])

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [modalTableControl, setModalTableControl] = useState(false)
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [URL, setURL] = useState("");
	const [pageCount, setPageCount] = useState(0)
	const [activeTab, setActiveTab] = useState('product')
	const [categoryData, setCategoryData] = useState([])
	const [categoryPageCount, setCategoryPageCount] = useState(0)
	const [categoryURL, setCategoryURL] = useState("")

	const [filterData, setFilterData] = useState({
		startDate: formatDateBackend(new Date(date.getFullYear(), date.getMonth(), 1)),
		endDate: formatDateBackend(new Date()),
		posId: reduxAccount.posId,
		search: '',
		categorySortKey: '',
		categorySortDirection: ',asc',
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-returned-items',
		response: null
	})

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		var filterUrl = "/services/web/api/report-returned-items"
		var urlParams = ""
		checkFilter()

		if (filterData.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.cashierId)
			urlParams += returnSign(urlParams) + 'cashierId=' + filterData.cashierId
		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if ("/services/web/api/report-returned-items" + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort
			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + filterDataCopy.tableSortDirection
		} else if (filterData.tableSortKey) {
			urlParams += returnSign(urlParams) + 'sort=' + filterData.tableSortKey + filterData.tableSortDirection
		}

		filterUrl = filterUrl + urlParams
		setURL(filterUrl);

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-returned-items-excel" + urlParams + returnSign(filterUrl)

			var excelHeaders = [[t('POS'), t('PRODUCT_ID'), t('NAME_OF_PRODUCT'), t('BARCODE'),
			t('QUANTITY'), t('TOTAL_AMOUNT'), t('DATE')]]
			const response = await GET(filterUrl)
			for (let i = 0; i < response.length; i++) {
				var excelItems = []
				excelItems.push(response[i].posName)
				excelItems.push(response[i].productId)
				excelItems.push(response[i].productName)
				excelItems.push(response[i].productBarcode)
				excelItems.push(response[i].quantity)
				excelItems.push(response[i].totalAmount)
				excelItems.push(formatDateWithTime(response[i].actionDate))
				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('RETURN_OF_GOODS') + ".xlsx");
		} else {
			const response = await PGET(filterUrl, {}, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
			}

			filterUrl = "/services/web/api/report-returned-items-total" + urlParams
			const temporaryTotalAmount = await GET(filterUrl)
			setTotalAmont(temporaryTotalAmount)
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		setFilterData({
			startDate: null,
			endDate: null,
			posId: null,
			search: '',
		})
		setFilterDataExist(false)
		if (activeTab === 'product') {
			getData()
		} else {
			resetCategoryData()
		}
	}

	async function getData() {
		const baseUrl = "/services/web/api/report-returned-items"
		const response = await PGET(baseUrl, { size: ItemsPerPage }, { loader: true })
		if (response) {
			setURL(baseUrl)
			setPagination({ ...pagination, 'url': baseUrl, 'response': response })
			setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
			setData(response.data)
		}
		const response2 = await GET("/services/web/api/report-returned-items-total", {}, { loader: false })
		if (response2) {
			setTotalAmont(response2)
		}
	}

	async function resetCategoryData() {
		const baseUrl = "/services/web/api/report-returned-items-by-category"
		const response = await PGET(baseUrl, { size: ItemsPerPage }, { loader: true })
		if (response) {
			setCategoryURL(baseUrl)
			setCategoryData(response.data)
			setCategoryPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		}
	}

	function checkFilter() {
		if (
			filterData.startDate === null &&
			filterData.endDate === null &&
			filterData.posId === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			response.unshift({ 'id': null, 'name': t('ALL') })
			setPoses(response)
		}
	}

	async function getCashiers() {
		const response = await GET('/services/web/api/cashier-helper')
		if (response) {
			setCashiers(response)
		}
	}

	async function paginate(data) {
		const response = await PGET(URL, { ...filterData, page: data.selected, size: ItemsPerPage }, { loader: true })
		setFilterData({ ...filterData, page: data.selected })
		setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		setData(response.data);
	}

	async function searchWithFilterByCategory(tableSort = '') {
		const params = { size: ItemsPerPage }
		if (filterData.posId) params.posId = filterData.posId
		if (filterData.cashierId) params.cashierId = filterData.cashierId
		if (filterData.startDate) params.startDate = filterData.startDate
		if (filterData.endDate) params.endDate = filterData.endDate
		if (filterData.search) params.search = filterData.search

		let sortValue = ''
		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.categorySortKey === tableSort) {
				filterDataCopy.categorySortDirection === ',asc' ? filterDataCopy.categorySortDirection = ',desc' : filterDataCopy.categorySortDirection = ',asc'
			} else {
				filterDataCopy.categorySortDirection = ',asc'
			}
			filterDataCopy.categorySortKey = tableSort
			setFilterData(filterDataCopy)
			sortValue = tableSort + filterDataCopy.categorySortDirection
		} else if (filterData.categorySortKey) {
			sortValue = filterData.categorySortKey + filterData.categorySortDirection
		}
		if (sortValue) params.sort = sortValue

		const baseUrl = "/services/web/api/report-returned-items-by-category"
		setCategoryURL(baseUrl)
		const response = await PGET(baseUrl, params, { loader: true })
		if (response) {
			setCategoryData(response.data)
			setCategoryPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		}
		setDropdownIsOpen(false)
	}

	async function downloadCategoryExcel() {
		var urlParams = ""
		if (filterData.posId) urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.cashierId) urlParams += returnSign(urlParams) + 'cashierId=' + filterData.cashierId
		if (filterData.startDate) urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate) urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search) urlParams += returnSign(urlParams) + 'search=' + filterData.search

		const response = await GET("/services/web/api/report-returned-items-by-category-excel" + urlParams)
		if (response) {
			var excelHeaders = [[t('POS'), t('CATEGORY_CORE'), t('CATEGORY_NAME'), t('QUANTITY'), t('TOTAL_AMOUNT'), t('CURRENCY')]]
			for (let i = 0; i < response.length; i++) {
				excelHeaders.push([
					response[i].posName,
					response[i].parentCategoryName,
					response[i].categoryName,
					response[i].balance,
					response[i].totalAmount,
					response[i].currencyName,
				])
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders)
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
			XLSX.writeFile(wb, t('RETURN_OF_GOODS') + ".xlsx")
		}
	}

	async function paginateCategory(data) {
		const params = { page: data.selected, size: ItemsPerPage }
		if (filterData.posId) params.posId = filterData.posId
		if (filterData.cashierId) params.cashierId = filterData.cashierId
		if (filterData.startDate) params.startDate = filterData.startDate
		if (filterData.endDate) params.endDate = filterData.endDate
		if (filterData.search) params.search = filterData.search
		if (filterData.categorySortKey) params.sort = filterData.categorySortKey + filterData.categorySortDirection

		const response = await PGET(categoryURL || "/services/web/api/report-returned-items-by-category", params, { loader: true })
		if (response) {
			setCategoryData(response.data)
			setCategoryPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		}
	}

	useEffect(() => {
		getPoses()
		getCashiers()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (activeTab === 'product') {
			searchWithFilter(false)
		} else {
			searchWithFilterByCategory()
		}
	}, [filterData.search, ItemsPerPage, activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('RETURN_OF_GOODS')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}
									disableGroupSearch>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CASHIER')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.id === filterData.cashierId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'cashierId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => activeTab === 'product' ? searchWithFilter(false) : searchWithFilterByCategory()}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide" onClick={() => activeTab === 'product' ? searchWithFilter(true) : downloadCategoryExcel()}>EXCEL</button>
							</div>
						</div>
						<div className="d-flex">
							<div className="vertical-center me-2">
								<h4>
									<b>{t('TOTAL_AMOUNT')}</b>:
								</h4>
							</div>
							<div className="vertical-center">
								{totalAmount?.map((item, index) => (
									<h5 className="text-end" key={index}>
										<span className="me-1">{formatMoney(item.totalAmount)}</span>
										<b>{item.currencyName}</b>
									</h5>
								))
								}
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.cashierId &&
									<span className="me-2">
										<b>{t('CASHIER')}: </b> {findFromArrayById(cashiers, filterData.cashierId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					{/* <ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e); // Update ItemsPerPage
							setFilterData({ ...filterData, page: 0, random: filterData.random + 1 }); // Reset to the first page
						}}
					/> */}

					<ul className="nav nav-tabs mb-3">
						<li className="nav-item">
							<button
								className={'nav-link ' + (activeTab === 'product' ? 'active' : '')}
								onClick={() => setActiveTab('product')}
							>
								{t('NAME_OF_PRODUCT')}
							</button>
						</li>
						<li className="nav-item">
							<button
								className={'nav-link ' + (activeTab === 'category' ? 'active' : '')}
								onClick={() => setActiveTab('category')}
							>
								{t('CATEGORY_NAME')}
							</button>
						</li>
					</ul>

					{activeTab === 'product' && <>
					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'posName')}>
										{t('POS')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'productName')}>
										{t('NAME_OF_PRODUCT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReportReturnProducts || reduxSettings.tableReportReturnProducts?.categoryName) &&
										<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'categoryName')}>
											{t('CATEGORY')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'productBarcode')}>
										{t('BARCODE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReportReturnProducts || reduxSettings.tableReportReturnProducts?.artikul) &&
										<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'productArtikul')}>
											{t('ARTIKUL')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'quantity')}>
										{t('QUANTITY')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'quantity') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'quantity') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'totalAmount')}>
										{t('TOTAL_AMOUNT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'actionDate')}>
										<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
										{t('DATE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'actionDate') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'actionDate') && 'sort-active')}></i>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td>{item.rowNum}. {item.posName}</td>
										<td>{item.productName}</td>
										{(!reduxSettings.tableReportReturnProducts || reduxSettings.tableReportReturnProducts?.categoryName) &&
											<td className="text-center">{item.categoryName}</td>
										}
										<td className="text-center">{item.productBarcode}</td>
										{(!reduxSettings.tableReportReturnProducts || reduxSettings.tableReportReturnProducts?.artikul) &&
											<td className="text-center">{item.productArtikul}</td>
										}
										<td className="text-center">{item.quantity}</td>
										<td className="text-center text-nowrap">{formatMoney(item.totalAmount)}</td>
										<td className="text-center text-nowrap">{formatDateWithTime(item.actionDate)}</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} reduxPage={filterData.page}></Pagination>
					</>}

					{activeTab === 'category' && <>
						<div className="table-responsive">
							<table className="table table-striped mb-0">
								<thead>
									<tr>
										<th className="th-sortable cursor" onClick={() => searchWithFilterByCategory('posName')}>
											{t('POS')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.categorySortDirection === ',asc' && filterData.categorySortKey === 'posName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.categorySortDirection === ',desc' && filterData.categorySortKey === 'posName') && 'sort-active')}></i>
											</div>
										</th>
										<th>{t('CATEGORY_CORE')}</th>
										<th className="th-sortable cursor" onClick={() => searchWithFilterByCategory('categoryName')}>
											{t('CATEGORY_NAME')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.categorySortDirection === ',asc' && filterData.categorySortKey === 'categoryName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.categorySortDirection === ',desc' && filterData.categorySortKey === 'categoryName') && 'sort-active')}></i>
											</div>
										</th>
										<th className="th-sortable cursor text-center" onClick={() => searchWithFilterByCategory('balance')}>
											{t('QUANTITY')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.categorySortDirection === ',asc' && filterData.categorySortKey === 'balance') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.categorySortDirection === ',desc' && filterData.categorySortKey === 'balance') && 'sort-active')}></i>
											</div>
										</th>
										<th className="th-sortable cursor text-center" onClick={() => searchWithFilterByCategory('totalAmount')}>
											{t('TOTAL_AMOUNT')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.categorySortDirection === ',asc' && filterData.categorySortKey === 'totalAmount') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.categorySortDirection === ',desc' && filterData.categorySortKey === 'totalAmount') && 'sort-active')}></i>
											</div>
										</th>
										<th className="text-center">{t('CURRENCY')}</th>
									</tr>
								</thead>
								<tbody>
									{categoryData?.map((item, index) => (
										<tr key={index}>
											<td>{item.rowNum}. {item.posName}</td>
											<td>{item.parentCategoryName}</td>
											<td>{item.categoryName}</td>
											<td className="text-center">{formatMoney(item.balance)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.totalAmount)}</td>
											<td className="text-center">{item.currencyName}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<Pagination pageCount={categoryPageCount} paginate={paginateCategory}></Pagination>
					</>}

				</div>
			</div>

			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableReportReturnProducts'}>
			</TableControl>
			{/* MODAL TABLE CONTROL */}
		</>
	)
}

export default Index
